import React from 'react';

const ErpSection = () => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        
        {/* Left Side: Content */}
        <div style={styles.leftContent}>
          <p style={styles.badge}>#1 ERP SOLUTIONS & DIGITAL LIFECYCLE TRANSFORMATION PARTNER</p>
          <h1 style={styles.mainHeading}>
            Enterprise Resource Planning (ERP)<br />
            Software Services
          </h1>
          <div style={styles.highlightText}>
            <p>• 15+ Years of Enterprise Software Experience</p>
            <p>• Industry-Focused ERP Consultants & Engineers</p>
            <p>• Manufacturing, Textile & Distribution Domain Experts</p>
          </div>
          <p style={styles.description}>
            Streamline your business operations and eliminate data silos with a unified ERP platform.
            Our ERP solutions help you seamlessly manage finance, inventory, production, sales, and HR—enabling real-time visibility, process automation, compliance, and scalable growth through a secure and flexible digital foundation.
          </p>

          {/* Updated Button with SVG Icon */}
          <button style={styles.ctaButton}>
            Request a demo 
            <svg 
              width="20" 
              height="20" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              style={{ marginLeft: '10px' }}
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>

        {/* Right Side: Photo */}
        <div style={styles.rightImage}>
          <img 
            src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=1000" 
            alt="ERP Dashboard" 
            style={styles.heroImg}
          />
          <div style={styles.floatingCard}>
            <p style={{margin: 0, fontSize: '12px', color: '#888'}}>Production Growth</p>
            <h3 style={{margin: 0, color: '#00ff88'}}>+28%</h3>
          </div>
        </div>

      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    backgroundColor: '#05070a',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    color: '#fff',
    padding: '0 5%',
  },
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '50px',
    maxWidth: '1200px',
    alignItems: 'center',
  },
  leftContent: {
    textAlign: 'left',
  },
  badge: {
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '1.5px',
    marginBottom: '20px',
    opacity: 0.8,
  },
  mainHeading: {
    fontSize: '35px',
    lineHeight: '1.5',
    marginBottom: '20px',
    fontWeight: '600',
  },
  highlightText: {
    marginBottom: '20px',
    fontSize: '18px',
    lineHeight: '1.8',
  },
  description: {
    fontSize: '16px',
    color: '#a0a0a0',
    lineHeight: '1.6',
    marginBottom: '30px',
    maxWidth: '500px',
  },
  ctaButton: {
    backgroundColor: '#007bff',
    color: 'white',
    padding: '12px 25px',
    border: 'none',
    borderRadius: '25px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: '0.3s',
    display: 'flex',       
    alignItems: 'center',
  },
  rightImage: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
  },
  heroImg: {
    width: '100%',
    borderRadius: '15px',
    boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
    border: '1px solid #333',
  },
  floatingCard: {
    position: 'absolute',
    top: '20px',
    right: '-20px',
    backgroundColor: '#1a1d23',
    padding: '15px',
    borderRadius: '10px',
    border: '1px solid #333',
    boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
  }
};

export default ErpSection;